import React from 'react';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import Card from '../../Reusable/Card';
import APIS from '../../../constant/Endpoint';
import useGetHook from '../../../customHooks/useGetHook';

const EmailCardContent = ({ data, isLoading }) => {
  return (
    <>
      {isLoading ? (
        <div className={tw`flex gap-4`}>
          {Array.from({ length: 4 }).map((item, index) => (
            <div
              key={index}
              className={tw`w-full h-20 bg-gray-300 animate-pulse`}
            ></div>
          ))}
        </div>
      ) : (
        <div className={tw`flex gap-4`}>
          <Card>
            <div className={tw`bg-white rounded-lg shadow-sm p-4 w-40`}>
              <h3 className={tw`text-base font-semibold text-gray-900`}>
                Email Sent
              </h3>
              <p className={tw`text-sm text-gray-600`}>Last 30 days</p>
            </div>
          </Card>
          <Card>
            <div className={tw`bg-white rounded-lg shadow-sm p-4 w-40`}>
              <h3 className={tw`text-base font-semibold text-gray-900`}>
                Sms Sent
              </h3>
              <p className={tw`text-sm text-gray-600`}>Last 30 days</p>
            </div>
          </Card>
          <Card>
            <div className={tw`bg-white rounded-lg shadow-sm p-4 w-40`}>
              <h3 className={tw`text-base font-semibold text-gray-900`}>
                Avaliable Sms
              </h3>
              <p className={tw`text-sm text-gray-600`}>
                {data?.sms_count ?? 0}
              </p>
            </div>
          </Card>
          <Card>
            <div className={tw`bg-white rounded-lg shadow-sm p-4 w-40`}>
              <h3 className={tw`text-base font-semibold text-gray-900`}>
                Avaliable Email
              </h3>
              <p className={tw`text-sm text-gray-600`}>0</p>
            </div>
          </Card>
        </div>
      )}
    </>
  );
};

export default EmailCardContent;
